export const notificationConfig = {
    success: {
      position: "top-center",
      autoClose: 2000,
      pauseOnHover: true,
      draggable: true,
      theme: "dark",
    },
    error: {
      position: "top-right",
      autoClose: 2000,
      pauseOnHover: true,
    },
  };